import React from 'react'
import { Button, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import AddIcon from '@material-ui/icons/Add'
import {
  useProductFromQueryParam,
  addOligoLabel,
} from '@src/routes/Configurators/products/TubesMTORedesign/ProductsConfiguration'

const useStyles = makeStyles((theme: Theme) => ({
  buttonStyle: (props: { alignment: 'left' | 'center' | 'right' }) => ({
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightBold,
    padding: theme.spacing(0),
    '& .MuiButton-text': {
      padding: theme.spacing(0),
    },
    '& .MuiButton-root': {
      padding: theme.spacing(0),
    },
    '& .MuiButton-label': {
      justifyContent:
        props.alignment === 'right'
          ? 'flex-end'
          : props.alignment === 'center'
            ? 'center'
            : 'flex-start',
    },
  }),
}))

interface AddOligoButtonProps {
  handleAddOligo: () => void
  alignment?: 'left' | 'center' | 'right'
  disabled?: boolean
}

const AddOligoButton: React.FC<AddOligoButtonProps> = ({
  handleAddOligo,
  alignment = 'left',
  disabled,
}) => {
  const classes = useStyles({ alignment })
  const product = useProductFromQueryParam()
  return (
    <Button
      size="medium"
      startIcon={<AddIcon />}
      className={classes.buttonStyle}
      onClick={handleAddOligo}
      disabled={!!disabled}
    >
      {addOligoLabel(product)}
    </Button>
  )
}

export default AddOligoButton
